/**
 * @figma https://www.figma.com/file/BQI0Ue9AtKa7BMXXOLULA9/Fortress%3A-Foundations?type=design&node-id=770-2748&mode=design&t=g51V8yGoNbQ5AV3K-0
 */

export default {
  values: {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536,
    /**
     * @deprecated
     */
    mobile: 0,
    /**
     * @deprecated
     */
    tablet: 600,

    /**
     * @deprecated
     */
    desktop: 900,
  },
};
